<template>
    <v-container class="pagelogin">
    <div style="height: 18vh;"></div>
    <div class="loginForm">
  
      <v-card
      class="mx-auto pa-12 pb-8 login-card"
        elevation="8"
        max-height="615px"
        rounded="lg"
        width="400px"
      >
        <h2>Reset my password</h2>
        <br>

        <div class="text-subtitle-1 text-medium-emphasis">Email</div>
  
        <v-text-field
          density="compact"
          placeholder="Email address"
          prepend-inner-icon="mdi-email-outline"
          variant="outlined"
          v-model="email"
        ></v-text-field>
  
        <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
          Captcha
        </div>
        <CaptchaWidget ref="altchaWidget" @captcha-verified="handleCaptchaVerified"></CaptchaWidget>
        <br>
  
  
        <v-btn
          block
          class="mb-8"
          color="blue"
          size="large"
          variant="tonal"
          @click="send_reset_link"
        >
        Send reset link
        </v-btn>
      </v-card>
    </div>
  </v-container>
  </template>
  
  <script>
  import CaptchaWidget from '@/components/CaptchaWidget.vue';
  import { useToast } from "vue-toastification";
  import { mapGetters } from 'vuex';
  
  export default {
    data: () => ({
      email: '',
      password: '',
      passwordVisible: false,
      captcha_payload: null
    }),
 
    computed: {
      ...mapGetters(['backend']),
    },
  
    components: {
      CaptchaWidget
    },
  
    methods: {
      handleCaptchaVerified(payload) { this.captcha_payload = payload },
      async send_reset_link(){
        const toast = useToast();
        try{
          const response = await this.$axios.post(`${this.backend}/api/user/forgot-password`, {
            email: this.email,
          });
          const res = response.data.message
          toast.success(res)
        }catch(err){
          toast.error((err.response.data.error).toString())
        }
        this.$refs.altchaWidget.resetCaptcha();
        this.captcha_payload = null
      }
    }
  }
  </script>
  
  <style scoped>
  
  .pagelogin{
    display: flex;
      align-items: center; 
      justify-content: center;
      height: 100vh;  
  }
  
    .loginForm {
      display: flex;
      flex-direction: column;
      align-items: center; 
      justify-content: flex-start; 
      position: relative;
    }
  
    .login-card{
      background-color: rgba(34, 34, 34, 0.459);
    }
  
    
  
  </style>
  